export const SEQUENCE_CANVAS_ID = "sequence_canvas_id"

export const SEQUENCE_COMPOSITION_CONTAINER_ID = "sequence_composition_container_id"